package model

import kotlinx.serialization.Serializable

@Serializable
data class SmsAuthenticationBody(
    val phoneNumber: Long
)